import {
  FETCH_BUSINESS_UNIT_FAILURE,
  FETCH_BUSINESS_UNIT_REQUEST,
  FETCH_BUSINESS_UNIT_SUCCESS,
  UPDATE_BUSINESS_UNIT_REQUEST,
  UPDATE_BUSINESS_UNIT_SUCCESS,
  UPDATE_BUSINESS_UNIT_FAILURE,
  CREATE_BUSINESS_UNIT_REQUEST,
  CREATE_BUSINESS_UNIT_SUCCESS,
  CREATE_BUSINESS_UNIT_FAILURE,
} from "../../actions/BusinessUnit/types";

/**
 *
 * @type FetchBusinessUnit
 */
const initialState = {
  createBusinessUnit: { loading: false, data: null, error: null },
  updateBusinessUnit: { loading: false, data: null, error: null },
  businessUnitList: { loading: false, data: null, error: null },
  // loading: false,
  // data: null,
  // error: null
};

/**
 *
 *
 *
 * @typedef {Object} ACTION
 * @property {string} type
 * @property {Array<*>} [payload]
 * @property {string} [error]
 *
 *
 *
 * @param { FetchBusinessUnit} state
 * @param {ACTION} action
 * @param {*} type
 *
 * @return {FetchBusinessUnit}
 */
const BusinessUnit = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BUSINESS_UNIT_REQUEST:
      return {
        ...state,
        businessUnitList: { ...initialState.businessUnitList, loading: true },

        // loading: true,
        // error: null
      };
    case FETCH_BUSINESS_UNIT_SUCCESS:
      return {
        ...state,
        businessUnitList: {
          ...state.businessUnitList,
          loading: false,
          error: null,
          data: action.payload,
        },
        // loading: false,
        // data: action.payload,
        // error: null
      };
    case FETCH_BUSINESS_UNIT_FAILURE:
      return {
        ...state,
        businessUnitList: { data: null, loading: false, error: action.error },
        // loading: false,
        // error: action.error
      };

    case CREATE_BUSINESS_UNIT_REQUEST:
      return {
        ...state,
        createBusinessUnit: {
          ...initialState.createBusinessUnit,
          loading: true,
        },
      };
    case CREATE_BUSINESS_UNIT_SUCCESS: {
      return {
        ...state,
        createBusinessUnit: {
          ...state.createBusinessUnit,
          payload: action.payload,
          loading: false,
          error: null,
        },
        businessUnitList: addNewBusinessUnitData(action.payload, {
          ...state.businessUnitList,
        }),
      };
    }
    case CREATE_BUSINESS_UNIT_FAILURE:
      return {
        ...state,
        createBusinessUnit: { data: null, loading: false, error: action.error },
      };

    case UPDATE_BUSINESS_UNIT_REQUEST:
      return {
        ...state,
        createBusinessUnit: {
          ...initialState.createBusinessUnit,
          loading: true,
        },
      };
    case UPDATE_BUSINESS_UNIT_SUCCESS: {
      return {
        ...state,
        updateBusinessUnit: {
          ...state.updateBusinessUnit,
          loading: false,
          error: null,
          payload: action.payload,
        },
        businessUnitList: updateBusinessUnitData(action.payload, {
          ...state.businessUnitList,
        }),
      };
    }
    case UPDATE_BUSINESS_UNIT_FAILURE:
      return {
        ...state,
        updateBusinessUnit: { data: null, loading: false, error: action.error },
      };
    default:
      return state;
  }
};

/**
 *
 * @param {BusinessUnit} dataToUpdate
 * @param {BusinessUnitListState} state
 * @returns {BusinessUnitListState}
 */
function updateBusinessUnitData(dataToUpdate, state) {
  state.data.data = state.data.data.map((obj) => {
    if (obj._id !== dataToUpdate._id) return obj;
    return { ...dataToUpdate };
  });

  return state;
}

/**
 *
 * @param {BusinessUnit} dataToUpdate
 * @param {BusinessUnitListState} state
 * @returns {BusinessUnitListState}
 */
function addNewBusinessUnitData(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}

export default BusinessUnit;
